import { Overlays } from "./overlays";

import { xCore } from './core';
import { URN as NSURN } from './utils/urn';
import { NSFunctions } from './utils/functions';
import { Map as Module_Map } from './map';


import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import { Fill, Icon, Stroke, Style, Circle as CircleStyle, RegularShape, Text } from 'ol/style';

import { bbox } from 'ol/loadingstrategy';
import { NSServerCalls } from './utils/servercalls';

export let OverlaysVector = {};

let o_struct_overlays;

OverlaysVector.init = function (o_struct_overlays_in) {

    o_struct_overlays = o_struct_overlays_in;
}

OverlaysVector.f_add_vector_layer = function (tree_node) {

    let a_urn_info = NSURN.f_get_urn_info(tree_node.urn);
    let s_urn_table = a_urn_info[2];

    let b_decluter = (tree_node.vector_tiles_simplify_data_on_map == true) ? true : false;
    let s_geoserver_layer_name = ( tree_node.geo_server_layer_name != null &&  tree_node.geo_server_layer_name.length > 0 ) ? tree_node.geo_server_layer_name : s_urn_table;

    var vectorSource = new VectorSource({
        format: new GeoJSON(),
        strategy: bbox,
        loader: function (extent, resolution, projection) {

            let proj = projection.getCode();

            let s_geometry_internal_name = tree_node.geometry_urn;
            let s_property_name_list  = null;
            
            s_property_name_list = s_geometry_internal_name + (tree_node.label_col_internal_name ? ',' + tree_node.label_col_internal_name : ''); // feature properties comma separeted list

            let s_cache_limitation_param_value = NSFunctions.guidGenerator();
            NSServerCalls.geoserver.wfs.get_feature(s_geoserver_layer_name, 100000, extent, null, null,
                function (o_resp_json) {
                    let o_gj = o_resp_json;
                    vectorSource.addFeatures(vectorSource.getFormat().readFeatures(o_gj));
                },
                s_cache_limitation_param_value,
                s_property_name_list // properties to be returned in feature by service
            );

        }
    });

    var o_vl = new VectorLayer({
        source: vectorSource,
        style: (feature) => f_get_style(feature, tree_node),
        declutter: b_decluter
    });

    let overlay_vector = new Overlays.objs.OverlayVector({ tree_node: tree_node });
    overlay_vector.o_vl = o_vl;

    o_struct_overlays.f_add_vector_overlay(overlay_vector);

    var map = Module_Map.f_get_map();
    map.addLayer(o_vl);
}

OverlaysVector.f_remove_vector_layer = function (tree_node) {
    //console.log("overlays_vector.js -  OverlaysVector.f_remove_vector_layer")

    let overlay = o_struct_overlays.f_get_vector_overlay(tree_node.id);
    let map = Module_Map.f_get_map();

    map.removeLayer(overlay.o_vl);

    o_struct_overlays.f_remove_vector_overlay(tree_node.id);
}

let f_get_style = function (feature, tree_node) {

    let s_stroke_color = tree_node.style.strokeColor ?? '#000000'; 
    let s_stroke_weight = tree_node.style.strokeWeight ?? 1;
    let s_stroke_opacity = tree_node.style.strokeOpacity ?? 1;
    let s_stroke_line_dash = tree_node.style.strokeDashed ? [5, 5, 15, 5] : [];
    let s_fill_color = tree_node.style.fillColor ?? '#000000';
    let s_fill_opacity = tree_node.style.fillOpacity ?? 0.5;
    let s_icon = tree_node.icon;
    let s_geom_type_lc = feature.getGeometry().getType().toLowerCase();
    let b_is_icon = (s_icon && s_geom_type_lc == 'point')? true : false;

    if (tree_node.urn == 'urn__SEP__table__SEP__municipio__SEP__arvore') {        
        if (feature.getProperties().nome_cientifico == "Washingtonia filifera") {
            s_stroke_color = "#009900";
        } else if (feature.getProperties().nome_cientifico == "Cercis siliquastrum") {
            s_stroke_color = "#007700";
        } else if (feature.getProperties().nome_cientifico == "Persea americana") {
            s_stroke_color = "#005500";
        } else if (feature.getProperties().nome_cientifico == "Phoenix canariensis") {
            s_stroke_color = "#004400";
        }
    }

    let o_rgb_stroke_color = NSFunctions.convertHexColorToRgb(s_stroke_color);
    let o_rgb_fill_color = NSFunctions.convertHexColorToRgb(s_fill_color);
    
    let s_parsed_stroke_color = `rgb(${o_rgb_stroke_color.r}, ${o_rgb_stroke_color.g}, ${o_rgb_stroke_color.b}, ${s_stroke_opacity})`;
    let s_parsed_fill_color = `rgb(${o_rgb_fill_color.r}, ${o_rgb_fill_color.g}, ${o_rgb_fill_color.b}, ${s_fill_opacity})`;

    let o_fill = new Fill({ color: s_parsed_fill_color });
    let o_stroke = new Stroke({ color: s_parsed_stroke_color, width: s_stroke_weight, lineDash: s_stroke_line_dash });

    let image_style;
    //let i_icon_size;

    if(b_is_icon)
    {
        /*
            new Icon({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: 'data/icon.png',
            })
        */
        let s_icon_url = xCore.application.layer_images_base_path + "/" + s_icon;
        
        image_style = new Icon({
            //anchor: [0.5, 1.0], // for vertical displacement, so bottom tip points to geometry center
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: s_icon_url,
        })
    }
    else if (tree_node.urn == 'urn__SEP__table__SEP__municipio__SEP__arvore') {
        /*
          "Junta de Freguesia"

          "Não é municipal"
          "Loteador"
          "EMAC"
          "Outros"
          "CMC Outros"
          "Cascais Envolvente"
          "CMC"
          "DGEV CEVAR"
          "Cascais Ambiente"
          "DGEV" 
        */

        let a_group_1 = ["EMAC", "DGEV CEVAR", "DGEV"];
        let a_group_2 = ["Não é municipal", "Loteador", "Outros"];
        let s_shape_selector_value = feature.getProperties().gestor;
        if (a_group_1.indexOf(s_shape_selector_value) > -1) {
            //square
            image_style = new RegularShape({
                fill: o_fill,
                stroke: o_stroke,
                points: 4,
                radius: 10,
                angle: Math.PI / 4,
            });

        }
        else if (a_group_1.indexOf(s_shape_selector_value) > -1) {
            //rectangle
            image_style = new RegularShape({
                fill: o_fill,
                stroke: o_stroke,
                points: 4,
                radius: 10,
                angle: Math.PI / 4,
            });

        }
        else {
            //circle
            image_style = new CircleStyle({
                radius: 20,
                //fill: null, -> will affect select event!!!!!!
                fill: o_fill,
                stroke: o_stroke,
            });
        }


    }
    else {
        image_style = new CircleStyle({
            radius: 25,
            //fill: null, -> will affect select event!!!!!!
            fill: o_fill,
            stroke: o_stroke,
        });
    }

    var o_style = new Style({
        image: image_style,
        fill: o_fill,
        stroke: o_stroke,
        text: f_get_text(feature, tree_node),
    });

    if(b_is_icon)
    {
        let icon_size = image_style.getSize();
        let icon_displacement = image_style.getDisplacement();
        
        feature.custom_extra_info = {};
        feature.custom_extra_info.b_is_icon = b_is_icon;
        feature.custom_extra_info.icon_size = icon_size;
        feature.custom_extra_info.icon_displacement = icon_displacement;
    }


    return o_style;
}

let f_get_text = function (o_feature, tree_node) {
    if (!tree_node.label_col_internal_name) return null;
    
    const label = o_feature.getProperties()[tree_node.label_col_internal_name];

    if (!label) return null;

    return new Text({
        textAlign: 'center',
        textBaseline: 'top', // Align text from the top
        offsetY: 10,          // Shift label 10 pixels downward
        text: f_string_divider(label),
        font: 'bold 11px sans-serif'
    });
}

// https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
let f_string_divider = function (str) {
    if (str.length > 16) {
        let p = 16;
        while (p > 0 && str[p] != " " && str[p] != "-") {
            p--;
        }
        if (p > 0) {
            let left;
            if (str.substring(p, p + 1) == "-") {
                left = str.substring(0, p + 1);
            } else {
                left = str.substring(0, p);
            }
            const right = str.substring(p + 1);
            return left + '\n' + stringDivider(right, 16, '\n');
        }
    }

    return str;
}